export default __webpack_public_path__ + "static/media/workExperience.23a84012.png";